/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

// Using CoinGecko Public API as a proxy for CoinMarketCap data without requiring backend secrets for this demo
const CG_API = "https://api.coingecko.com/api/v3";

export interface GlobalMarketData {
    active_cryptocurrencies: number;
    markets: number;
    total_market_cap: Record<string, number>;
    total_volume: Record<string, number>;
    market_cap_percentage: Record<string, number>;
}

export const getGlobalMarketData = async (): Promise<GlobalMarketData> => {
    try {
        const res = await fetch(`${CG_API}/global`);
        if(!res.ok) throw new Error("CG API Error");
        const data = await res.json();
        return data.data;
    } catch (e) {
        console.warn("Using mock global data");
        return {
            active_cryptocurrencies: 15234,
            markets: 1440,
            total_market_cap: { usd: 3200000000000 },
            total_volume: { usd: 87700000000 },
            market_cap_percentage: { btc: 56.9, eth: 16.2, sol: 4.1 }
        };
    }
}

export const getCoinData = async (ids: string[]) => {
    try {
        const res = await fetch(`${CG_API}/simple/price?ids=${ids.join(',')}&vs_currencies=usd&include_24hr_change=true`);
        if(!res.ok) throw new Error("CG Price Error");
        return await res.json();
    } catch (e) {
        return {};
    }
}